import React, { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { Button, ButtonGroup } from "@folio/stripes/components";
var NavComponent = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var navigation = useMemo(function () { return [
        {
            path: "/czna-users/users",
            label: intl.formatMessage({ id: "ui-czna-users.users.title" }),
        },
        {
            path: "/czna-users/organizations",
            label: intl.formatMessage({ id: "ui-czna-users.organizations.title" }),
        },
        {
            path: "/czna-users/audit-log",
            label: intl.formatMessage({ id: "ui-czna-users.auditLog.nav" }),
        },
        {
            path: "/czna-users/api-clients",
            label: intl.formatMessage({ id: "ui-czna-users.apiClients.nav" }),
        },
    ]; }, [intl]);
    var handleClick = useCallback(function (path) {
        if (pathname !== path)
            history.push(path);
    }, [history, pathname]);
    var isActive = function (path) {
        return pathname === path || pathname.startsWith("".concat(path, "/"));
    };
    return (React.createElement(ButtonGroup, null, navigation.map(function (route) { return (React.createElement(Button, { key: route.path, onClick: function () { return handleClick(route.path); }, buttonStyle: isActive(route.path) ? "primary" : "default", fullWidth: true, marginBottom0: true, style: { justifyContent: "flex-start" }, "aria-current": isActive(route.path) ? "page" : undefined },
        React.createElement("span", { style: { marginLeft: "0.5rem" } }, route.label))); })));
};
export default NavComponent;
